import './styles.scss';
import React from 'react';
import {Table, TablePaginationConfig} from "antd";
import {AlertsTableConfig} from "./Alerts.table.config";
import {IAlert} from "../../../api/Alert/Alert.types";

interface Props {
    data: IAlert[]
    pagination: TablePaginationConfig|false,
    onChange?:()=>void,
}

function AlertsTable({data, pagination}: Props) {

    return (
        <div className='users-table'>
            <div className='users-table-content'>
                <Table rowKey='id' dataSource={data} columns={AlertsTableConfig()}
                       pagination={pagination}/>
            </div>
        </div>
    )
}

export default AlertsTable;